/* 🤖 this file was generated by svg-to-ts */
export const IconBigBrandGoogle: {
    name: 'big-brand-google';
    data: string;
} = {
    name: 'big-brand-google',
    data: `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 40 40"><path d="M9.18 1.608C7.678.786 5.914.805 4.42 1.62l17.497 15.97 5.878-5.816zM2.672 3.253A4.4 4.4 0 0 0 2 5.573V34.42c0 .812.224 1.587.626 2.263l17.595-17.41zM35.588 16.03l-5.606-3.062-6.3 6.232 7.72 7.046 4.188-2.287c1.508-.827 2.41-2.308 2.41-3.966-.002-1.658-.902-3.14-2.412-3.964M21.985 20.882 4.342 38.34c.766.431 1.606.66 2.45.66a4.9 4.9 0 0 0 2.389-.615l20.008-10.927z"/></svg>`,
};
